'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _RetirementPlanGridTableWrap = require('./RetirementPlanGridTableWrap.css');

var _RetirementPlanGridTableWrap2 = _interopRequireDefault(_RetirementPlanGridTableWrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RetirementPlanGridTableWrap = (_dec = (0, _reactCssModules2.default)(_RetirementPlanGridTableWrap2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RetirementPlanGridTableWrap, _Component);

  function RetirementPlanGridTableWrap(props) {
    (0, _classCallCheck3.default)(this, RetirementPlanGridTableWrap);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RetirementPlanGridTableWrap.__proto__ || (0, _getPrototypeOf2.default)(RetirementPlanGridTableWrap)).call(this, props));

    _this.state = {
      viewAs: 0
    };
    return _this;
  }

  (0, _createClass3.default)(RetirementPlanGridTableWrap, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'rplc-btn-wrap' },
            _react2.default.createElement(
              'h3',
              { styleName: 'rplc-btn-label' },
              'View as:'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                {
                  styleName: 'rplc-btn',
                  onClick: function onClick() {
                    _this2.setState({ viewAs: 0 });
                  }
                },
                'Logos'
              ),
              _react2.default.createElement(
                'button',
                {
                  styleName: 'rplc-btn',
                  onClick: function onClick() {
                    _this2.setState({ viewAs: 1 });
                  }
                },
                'List'
              )
            )
          )
        ),
        this.state.viewAs === 0 ? _react2.default.createElement(_components.RetirementPlanGrid, null) : _react2.default.createElement(_components.RetirementPlanTable, null)
      );
    }
  }]);
  return RetirementPlanGridTableWrap;
}(_react.Component)) || _class);
exports.default = RetirementPlanGridTableWrap;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RetirementPlanGridTableWrap/RetirementPlanGridTableWrap.js
// module id = 1436
// module chunks = 0